import React from 'react';
import './index.css';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useStore } from 'helpers/store';
import { ConfigProvider } from 'antd';

import PasswordProtect from 'components/PasswordProtect';
import NotificationAlert from 'components/NotificationAlert';

import TrainingIndex from 'modules/TrainingIndex/TrainingIndex';
import SessionDetail from 'modules/TrainingIndex/SessionDetail';
import PreviousSessions from 'modules/TrainingIndex/PreviousSessions';
import EmployeeList from 'modules/TrainingIndex/EmployeeList';
import EmployeeReport from 'modules/TrainingIndex/EmployeeReport';
import TopicList from 'modules/TrainingIndex/TopicList';
import TopicReport from 'modules/TrainingIndex/TopicReport';

import StoreProductList from 'modules/StoreManager/StoreProductList';
import StoreMealCounts from 'modules/StoreManager/StoreMealCounts';
import StoreMenu from 'modules/StoreManager/StoreMenu';
import StoreEntry from 'modules/StoreManager/StoreEntry';
import StoreManager from 'modules/StoreManager/StoreManager';
import StoreLedgerReport from 'modules/StoreManager/StoreLedgerReport';
import StoreBalanceReport from 'modules/StoreManager/StoreBalanceReport';
import StoreDailyCostAnalysis from 'modules/StoreManager/StoreDailyCostAnalysis';
import StoreReports from 'modules/StoreManager/StoreReports';

import BillingHome from 'modules/BillingSystem/BillingHome';
import BillingSettings from 'modules/BillingSystem/BillingSettings';
import BillingReport from 'modules/BillingSystem/BillingReport';

import ResidencyDashboard from 'modules/ResidencyDashboard/ResidencyDashboard';
import RoomView from 'modules/ResidencyDashboard/RoomView';
import ManageEvents from 'modules/FolkConnectAdmin/ManageEvents';
import ManageFeed from 'modules/FolkConnectAdmin/ManageFeed';
import HabitsHistory from 'modules/FolkConnectAdmin/HabitsHistory';
import ContentCreatorArea from 'modules/FolkConnectAdmin/ContentCreatorArea';
import GuideArea from 'modules/FolkConnectAdmin/GuideArea';
import LinksPage from 'modules/LinksPage/LinksPage';

import ExplosionInstructions from 'modules/Miscellaneous/ExplosionInstructionsFromKrishna';
import SearchQRCode from 'modules/Miscellaneous/SearchQRCode';
import AttendQrCode from 'modules/Miscellaneous/AttendQrCode';
import PrasadamFeedback from 'modules/Miscellaneous/PrasadamFeedback';
import Dashboard from 'modules/Miscellaneous/Dashboard';
import EditableSundayAttendance from 'modules/Miscellaneous/EditableSundayAttendance';
import EventAttendance from 'modules/Miscellaneous/eventAttendance';
import FOLKDashboard from 'modules/Miscellaneous/folkdashboard';
import SundayReport from 'modules/Miscellaneous/SundayReport';
import GFYAttendance from 'modules/Miscellaneous/GFYAttendance';
import AOMCAttendance from 'modules/Miscellaneous/AOMCAttendance';
import AutoAttendance from 'modules/Miscellaneous/AutoAttendance';
import LateAttendance from 'modules/Miscellaneous/LateAttendance';
import BookingDashboard from 'modules/booking/BookingDashboard';
import AccommodationBooking from 'modules/booking/AccommodationBooking';


// Route Passwords Configuration
export const ROUTE_PASSWORDS = {
  AOMC_ATTENDANCE: "7392",
  GFY_ATTENDANCE: "5847",
  SUNDAY_ATTENDANCE: "9163",
  CLUB_ATTENDANCE: "4275",
  EVENT_ATTENDANCE: "8619",
  AUTO_ATTENDANCE: "8620",
  SUNDAY_REPORT: "3584"
};

export default function Root() {
    useStore();
    return (
        <ConfigProvider theme={{ token: {} }} message={{ placement: 'bottomCenter', duration: 5 }}>
            <>
            <NotificationAlert />
            <BrowserRouter>
            <Routes>
                <Route exact path="/training_index/previous_sessions" element={ <PreviousSessions /> } />
                <Route exact path="/training_index/session_detail" element={
                    <PasswordProtect password="Session@123"><SessionDetail /></PasswordProtect>
                }/>
                <Route exact path="/training_index/employee_list" element={ <EmployeeList /> }/>
                <Route exact path="/training_index/employee_report" element={ <EmployeeReport /> }/>
                <Route exact path="/training_index/topic_list" element={ <TopicList /> }/>
                <Route exact path="/training_index/topic_report" element={ <TopicReport /> }/>
                <Route exact path="/training_index" element={ <TrainingIndex /> }/>

                <Route exact path="/store_manager/store_reports" element={ <StoreReports
                    warehouse="Kitchen Store"/> }/>
                <Route exact path="/store_manager/store_reports/store_ledger_report"
                    element={ <StoreLedgerReport warehouse="Kitchen Store"/> }/>
                <Route exact path="/store_manager/store_reports/store_balance_report"
                    element={ <StoreBalanceReport warehouse="Kitchen Store"/> }/>
                <Route exact path="/store_manager/store_reports/daily_cost_analysis"
                    element={ <StoreDailyCostAnalysis warehouse="Kitchen Store"/> }/>

                <Route exact path="/store_manager/stock_in_entry" element={ <StoreEntry
                    warehouse="Kitchen Store" entryType="STOCK IN"/> }/>
                <Route exact path="/store_manager/stock_out_entry" element={ <StoreEntry
                    warehouse="Kitchen Store" entryType="STOCK OUT"/> }/>

                <Route exact path="/store_manager/meal_counts" element={ <StoreMealCounts
                    warehouse="Kitchen Store"/> }/>

                <Route exact path="/store_manager/store_product_list" element={ <StoreProductList
                    warehouse="Kitchen Store"/> }/>
                <Route exact path="/store_manager/store_menu" element={ <StoreMenu
                    warehouse="Kitchen Store"/> }/>
                <Route exact path="/store_manager" element={ <StoreManager
                    warehouse="Kitchen Store"/> }/>

                <Route exact path="/residency_dashboard/residency" element={ <RoomView /> }/>
                <Route exact path="/residency_dashboard" element={ <ResidencyDashboard /> }/>

                <Route exact path="/billing" element={ <BillingHome /> }/>
                <Route exact path="/billing/report" element={ <BillingReport /> }/>
                <Route exact path="/billing/settings" element={ <BillingSettings /> }/>

                <Route exact path="/manage_events" element={ <ManageEvents /> }/>
                <Route exact path="/manage_feed" element={ <ManageFeed /> }/>
                <Route exact path="/habits_history" element={ <HabitsHistory /> }/>
                <Route exact path="/content_creator_area" element={ <ContentCreatorArea /> }/>
                <Route exact path="/guide_area" element={ <GuideArea /> }/>

                <Route exact path="/links_page" element={ <LinksPage /> }/>

                <Route exact path="/prasadam_feedback" element={ <PrasadamFeedback /> }/>
                <Route exact path="/search_qr_code" element={ <SearchQRCode /> }/>
                <Route exact path="/attend_qr_code" element={ <AttendQrCode /> }/>
                
                {/* { <Route exact path="/sunday_class_attendance" element={ <SundayClassAttendance /> }/> } */}
                <Route exact path="/sunday_class_attendance" element={<FOLKDashboard /> }/>
                <Route exact path="/aomc_attendance" element={ <PasswordProtect password={ROUTE_PASSWORDS.AOMC_ATTENDANCE}> <AOMCAttendance /></PasswordProtect>  }/>
                <Route exact path="/gfy_attendance" element={ <PasswordProtect password={ROUTE_PASSWORDS.GFY_ATTENDANCE}><GFYAttendance /></PasswordProtect>  }/>
                <Route exact path="/sunday_attendance" element={<PasswordProtect password={ROUTE_PASSWORDS.SUNDAY_ATTENDANCE}><EditableSundayAttendance /></PasswordProtect>}/>
                <Route exact path="/club_attendance" element={ <PasswordProtect password={ROUTE_PASSWORDS.CLUB_ATTENDANCE}></PasswordProtect>  }/>
                <Route exact path="/event_attendance" element={ <PasswordProtect password={ROUTE_PASSWORDS.EVENT_ATTENDANCE}> <EventAttendance /> </PasswordProtect>  }/>
                <Route exact path="/auto_attendance" element={ <PasswordProtect password={ROUTE_PASSWORDS.AUTO_ATTENDANCE}> <AutoAttendance /> </PasswordProtect>  }/>
                <Route exact path="/late_attendance" element={ <PasswordProtect password={ROUTE_PASSWORDS.SUNDAY_ATTENDANCE}> <LateAttendance /> </PasswordProtect>  }/>
                <Route exact path="/report_details" element={ <PasswordProtect password={ROUTE_PASSWORDS.SUNDAY_REPORT}> <SundayReport /> </PasswordProtect>  }/>
             
                {/* <Route exact path="/auto_attendance" element={<AutoAttendance /> }/>     */}
                <Route exact path="/explosion_instructions" element={ <ExplosionInstructions /> }/>
                <Route exact path="/booking" element={ <AccommodationBooking/> }/>
                <Route exact path="/accomodation_booking.html" element={ <AccommodationBooking/> }/>
                <Route exact path="/accomodation_booking_seatable.html" element={ <AccommodationBooking/> }/>
                <Route exact path="/manual_accommodation_booking.html" element={ <AccommodationBooking/> }/>

                <Route path="*" element={
                    <div>Not Found (From React Router)</div>
                } />
            </Routes>
        </BrowserRouter>
        </>
        </ConfigProvider>
    );
}
